import React from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { IconBell } from '@tabler/icons-react'

import { Button } from '@/components/buttons/Button'
import { TOGGLE_PANEL } from '@/reducers/notifications/notifications.redux'

import { NotificationPanel } from './NotificationPanel'

import './NotificationBell.scss'

/**
 * @param {object} props
 * @param {boolean} props.collapsed - true when rendered in the collapsed
 *   sidebar; the panel anchors to the collapsed rail instead of the full
 *   sidebar width.
 */
export const NotificationBell = ({ collapsed = false }) => {
  const dispatch = useDispatch()
  const { unreadCount, panelOpen } = useSelector((state) => state.notifications)

  const handleClick = () => {
    dispatch({ type: TOGGLE_PANEL })
  }

  const ariaLabel = unreadCount > 0 ? `Notifications (${unreadCount} unread)` : 'Notifications'

  return (
    <div className="notification-bell-wrapper">
      <Button
        basic
        small
        square
        active={panelOpen}
        onClick={handleClick}
        data-testid="notification-bell"
        aria-label={ariaLabel}
        tooltip="Notifications"
        tooltipProps={{ placement: collapsed ? 'right' : 'top' }}
      >
        <IconBell size={20} />
        {unreadCount > 0 && (
          <span className="notification-bell__badge" data-testid="notification-badge">
            {unreadCount > 99 ? '99+' : unreadCount}
          </span>
        )}
      </Button>
      <NotificationPanel collapsed={collapsed} />
    </div>
  )
}
